var r=function(r,e){return Object.keys(e).reduce((function(e,n){var t=r+"-"+n;return e[n]=t,e}),{})};export{r as normalizeIds};
